import React, {Component} from "react";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {SafeImage} from "../../components/Shared/SafeImage";
import {formatMoney, formsCheckboxUpdater, formsUpdater, getFormFieldValue} from "../Applications/shared/shared";
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";
import {deleteData, postData} from "../../api/doLogin";
import {ConfirmDialog} from "../../components/Shared/ConfirmDialog";
import {ReplaceableImageWrapper} from "../../components/Shared/ReplaceableImageWrapper";

export default class StoreItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      categories: [],
      formData: {},
      editMode: false,
      shouldDelete: false
    }
  }

  closeMe() {
    this.cancelEdit();
    this.props.onClose && this.props.onClose();
  }

  cancelEdit() {
    this.setState({editMode: false, formData: {}, shouldDelete: false})
  }

  deleteMe() {
    this.setState({shouldDelete: true})
  }

  removeItem() {
    const self = this;
    deleteData(`store/product/${this.props.product.id || 0}`, {}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.props.onUpdate();
          self.closeMe();
        } else {
          console.error(data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  conditionCheckedInt(evt) {
    const target = {id: evt.target.id, checked: evt.target.checked ? 1 : 0};
    return {target};
  }

  saveForm() {
    const formData = this.state.formData;
    formData.cid = Number(formData.cid);
    formData.price = Number(formatMoney(Number(formData.price), 2, ".", ""));
    const self = this;
    postData(`store/${this.props.product.id || 0}/edit`, {...formData}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.props.onUpdate({...formData});
          self.closeMe();
        } else {
          console.error(data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  wrapHyperlinks(text) {
    return text.split(/(https?:\/\/[^\s]+)/g).map((part, index) => {
      if (index % 2 === 0) {
        return part; // Even indexes contain text
      } else {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        ); // Odd indexes contain URLs
      }
    });
  }

  render() {
    const product = this.props.product || {};
    let categoryDisplay = this.props.categories.find((cat) => cat.id === product.cid);
    return (
      <MakeDialog isOpen={!!this.props.product}
                  headerTag={"div"}
                  header={
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                      {!this.state.editMode ?
                        <h4>{product.title}</h4>
                        :
                        <Input
                          type="text"
                          id="title"
                          style={{width: 300, display: "inline"}}
                          value={getFormFieldValue(this.state.formData['title'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      }
                      <span style={{display: "flex", fontSize: 11}}>
                          <Button color="secondary"
                                  onClick={() => this.closeMe()}>Close</Button>
                    </span>
                    </div>
                  }
                  footer={
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                      {this.state.editMode ?
                        <React.Fragment>
                          <Button color="success"
                                  onClick={() => this.saveForm()}>Save</Button>
                          <Button color="secondary"
                                  onClick={() => this.cancelEdit()}>Cancel</Button>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          {hasPermission(RequiredPermission.StoreEdit) && (<Button color="primary"
                                                                                   onClick={() => this.setState({
                                                                                     editMode: true,
                                                                                     formData: product
                                                                                   })}>Edit</Button>)}
                          {hasPermission(RequiredPermission.StoreRemove) && (<Button color="danger"
                                                                                     onClick={() => this.deleteMe()}>Remove</Button>)}
                        </React.Fragment>
                      }
                      <Button color="secondary"
                              onClick={() => this.closeMe()}>Close</Button>
                    </div>
                  }
      >
        <Row>
          <Col xs={12} sm={3}>
            <ReplaceableImageWrapper canReplace={hasPermission(RequiredPermission.StoreEdit) && this.state.editMode}
                                     uploadURL={`store/photo/${product.id}`}
                                     renameFilename={`${product.id}.jpg`}
                                     acceptedMimes={['image/jpeg']}
                                     appendFormData={[{name: "action", value: "UploadFile"}]}
                                     limit={1}
                                     onReplace={(url, cb) => this.setState({
                                       formData: {
                                         ...this.state.formData,
                                         url: `${url[0].url}`
                                       }
                                     })}
            >
              <SafeImage src={this.state.formData.url || product.url || ""} width={175} height={"auto"}/>
            </ReplaceableImageWrapper>
          </Col>
          <Col xs={12} sm={9}>
            {hasPermission(RequiredPermission.StoreEdit) && (
              <div>
                <FormGroup className={"form-group-condensed"}>
                  <Label for="category">Category</Label>
                  {this.state.editMode ?
                    <Input
                      type="select"
                      id="cid"
                      style={{width: 300, display: "inline", marginLeft: 5}}
                      value={getFormFieldValue(this.state.formData['cid'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    >
                      <option key={0} disabled={true} value={""}>Please Choose</option>
                      {this.props.categories.map((category, index) => {
                        return (
                          <option key={index} value={Number(category.id)}>{category.display}</option>
                        )
                      })}
                    </Input>
                    :
                    <span>:&nbsp;{categoryDisplay && categoryDisplay.display || "Edit to Choose"}</span>
                  }
                </FormGroup>
                <span>
              Visible&nbsp;&nbsp;&nbsp;
                  <Label className="switch switch-text switch-primary">
                  <Input type="checkbox"
                         id={"visible"}
                         className="switch-input"
                         checked={!this.state.editMode ? product.visible === 1 : this.state.formData.visible === 1}
                         onChange={(evt) => formsCheckboxUpdater(this.conditionCheckedInt(evt), this.state['formData'], this)}
                         disabled={!this.state.editMode}/>
                  <span className="switch-label" data-on="yes" data-off="no"></span>
                  <span className="switch-handle"></span>
                </Label>
              </span>
                &nbsp;&nbsp;&nbsp;
                <span>
              Featured&nbsp;&nbsp;&nbsp;
                  <Label className="switch switch-text switch-secondary">
              <Input type="checkbox"
                     id={"featured"}
                     className="switch-input"
                     checked={!this.state.editMode ? product.featured === 1 : this.state.formData.featured === 1}
                     onChange={(evt) => formsCheckboxUpdater(this.conditionCheckedInt(evt), this.state['formData'], this)}
                     disabled={!this.state.editMode}/>
              <span className="switch-label" data-on="yes" data-off="no"></span>
              <span className="switch-handle"></span>
            </Label>
            </span>
              </div>
            )}
            <div style={{fontWeight: "bold"}}>{!this.state.editMode ?
              <React.Fragment>
                {`Price: $${formatMoney(product.price)}`}
              </React.Fragment>
              :
              <div style={{display: "inline"}}>
                Price: $
                <Input
                  type="number"
                  id="price"
                  style={{width: 150, display: "inline"}}
                  value={getFormFieldValue(this.state.formData['price'])}
                  onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                />
              </div>
            }
            </div>
            {!this.state.editMode ?
              <pre style={{whiteSpace: "pre-wrap"}}>{this.wrapHyperlinks(product.description)}</pre>
              :
              <Input
                type="textarea"
                id="description"
                rows={10}
                // autoFocus
                style={{fontSize: 12}}
                value={getFormFieldValue(this.state.formData['description'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              />
            }
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {!this.state.editMode ?
              <pre style={{whiteSpace: "pre-wrap"}}>{product.extended}</pre>
              :
              <Input
                type="textarea"
                id="extended"
                rows={5}
                // autoFocus
                style={{fontSize: 12}}
                value={getFormFieldValue(this.state.formData['extended'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              />
            }
          </Col>
        </Row>
        {/*<Row>*/}
        {/*  <Col xs={12}>*/}
        {/*    <pre style={{fontSize: 10, whiteSpace: "pre-wrap"}}>Prices subject to change. Please note production time, if required in-hands date comes before standard production and ground shipping times, order is subject to rush charges and expedited freight charges at buyers expense, if normal production and standard in hands date can not be met. Each order includes one or both of the following, one layout for approval and one final proof for final approval prior to production. Any changes after the final proof may be subject to additional proof charges. All artwork submitted by client is subject to review, any artwork that is not true eps, vector or pdf files may be subject to addition artwork charges.</pre>*/}
        {/*    <div style={{fontSize: 10}}>Unless stated in the product listing above, all products can be ordered*/}
        {/*      through*/}
        {/*      Branding Innovations. Phone: 253.265.0888*/}
        {/*    </div>*/}
        {/*  </Col>*/}
        {/*</Row>*/}

        {this.state.shouldDelete && (
          <ConfirmDialog isOpen={true}
                         onOk={() => this.removeItem()}
                         onCancel={() => this.cancelEdit()}
          >
            <div>Are you sure you want to delete this store item?</div>
          </ConfirmDialog>
        )}

      </MakeDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Store/StoreItem.js